//Core
import React from "react"

//Styles
import style from "./style.module.scss"

const classes = (...arg) => arg.join(" ")

const { OrderButton, disable } = style

const Button = ({ children, disabled = false, click = () => {} }) => (
  <button
    draggable={false}
    onClick={click}
    className={classes(OrderButton, disabled ? disable : "")}
  >
    {children}
  </button>
)

export default Button
